export class MemoryStorage {
  map: Map<string, unknown>;

  constructor() {
    this.map = new Map();
  }

  getItem(key: string): unknown {
    return this.map.get(key);
  }

  removeItem(key: string): boolean {
    return this.map.delete(key);
  }

  setItem(key: string, value: unknown): Map<string, unknown> {
    return this.map.set(key, value);
  }
}
